<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  tone: {
    type: String,
    default: 'warning',
    validator: value => ['danger', 'warning'].includes(value),
  },
});

const emit = defineEmits(['dismiss']);
const { t } = useI18n();
const alertGlyph = '!';
const classes = computed(() =>
  props.tone === 'danger'
    ? 'border-[#F9D2D2] bg-[#FDF2F2] text-[#464F53]'
    : 'border-[#FFF0CD] bg-[#FFFAF0] text-[#464F53]'
);
const iconBackgroundClass = computed(() =>
  props.tone === 'danger' ? 'bg-[#E33838]' : 'bg-[#FFC43E]'
);
const closeClass = computed(() =>
  props.tone === 'danger'
    ? 'text-[#E33838] hover:text-[#B91C1C]'
    : 'text-[#FFC43E] hover:text-[#D99A00]'
);
</script>

<template>
  <div
    role="alert"
    class="flex items-center justify-between gap-3 rounded-[10px] border py-[6px] pr-3 pl-4 font-roboto text-base leading-6"
    :class="classes"
  >
    <div class="flex min-w-0 items-center gap-3">
      <span
        class="grid size-5 shrink-0 place-items-center rounded-full text-xs font-bold leading-none text-white"
        :class="iconBackgroundClass"
        aria-hidden="true"
      >
        {{ alertGlyph }}
      </span>
      <p class="m-0 mr-7 py-2 text-sm leading-5"><slot /></p>
    </div>
    <button
      type="button"
      class="-mt-1 -mr-2 ml-4 rounded p-1 transition-opacity focus:outline-none focus:ring-2 focus:ring-current"
      :class="closeClass"
      :aria-label="t('SALES_PARTIES.DOCUMENTS.CLOSE_NOTICE')"
      @click="emit('dismiss')"
    >
      <span class="i-lucide-x size-4" aria-hidden="true" />
    </button>
  </div>
</template>
